import { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IoMdMore, IoMdSearch } from 'react-icons/io';
import ChatUserCard from './ChatUserCard';
import { Menu } from '@mui/material';
import { Outlet, useNavigate } from 'react-router';
import { UserAPI } from '../../../api/UserAPI';
import { CalendarAPI } from '../../../api/CalendarAPI.js'
import AddNewChat from './AddNewChat';
import { chatActions } from '../../../redux/reducer/chatReducer';
import appLogoImg from '../../../assets/images/SportMingleLogoMark.png';
import Loader from '../../../component/Loader.jsx';

function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}


const ChatRoom = () => {
    document.title = "Chat"
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const { allChatMessage, currentChat, openChat,chatList,totalUnreadMessage } = useSelector((store) => store.chat);
    const [anchorEl, setAnchorEl] = useState(null);
    const [users, setUsers] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [firstLoading, setFirstLoading] = useState(true);
    const [isUpdate, setIsUpdate] = useState(false);
    const [searchKey, setSearchKey] = useState('');
    const [isLoading, setIsLoading] = useState(false);


    // const fetchAllUserByName = async (name) => {
    //     try {
    //         const response = await UserAPI.getAllClubUserByName(selectedClub.clubId, name);
    //         setSearchedChats(response.Data)

    //     } catch (error) {
    //         console.log(error);
    //     }
    // };
    // const debounceSearch = useMemo(() => debounce(fetchAllUserByName, 500), []);

    const findAllChat = async (searchKey) => {
        //console.log('Print all chat');
        
        try {
            const response = await UserAPI.getAllChat(userInfo.userId, selectedClub.clubId,20,0,searchKey);
            dispatch(chatActions.setChatList(response.Data));
        } catch (error) {

        } finally {
            setFirstLoading(false);
        }
    }

    useEffect(() => {
        if (userInfo.userId) {
            findAllChat('');
        }
        isUpdate && setIsUpdate(false);
        return () => {
            if (!window.location.pathname.includes('/chat')) {
                dispatch(chatActions.setCurrentChat(null));
            }
        }
    }, [userInfo.userId, allChatMessage, isUpdate, selectedClub,totalUnreadMessage])
    useEffect(() => {
        navigate("/chat")
        dispatch(chatActions.setCurrentChat(null));


    }, [selectedClub])
    const handleClose = () => {
        setAnchorEl(null);
    };
    const openNewChat = async (event) => {
            const anchor = event.currentTarget;
            setAnchorEl(anchor);
    }
    if (firstLoading) {
        return <Loader />
    }

    const handleOpenChat = () => {
        if (window.innerWidth <= 800) {
            dispatch(chatActions.setOpenChat(!openChat));
        }
    };



    const handleChatSearch = async(name) => {
        setSearchKey(name);
        findAllChat(name);
    };

    return (
        <div className='sm_chat_room_conatiner'>
           {isLoading && <Loader/>}
            <div className='sm_chat_room_conatiner_body'>
                {window?.location?.pathname === '/chat' ?
                    <div className='sm_chat_page_intro_container'>
                        <img src={appLogoImg} alt="Sportmingle" />
                        <p>Keep your team in sync with real-time messaging.</p>
                        <p>Chat one-on-one or in groups, share updates instantly, and coordinate seamlessly.</p>
                    </div>
                    :
                    <Outlet />
                }
            </div>
            <div className={openChat ? 'sm_chat_user_list move' : 'sm_chat_user_list'}>
                <div className='sm_chat_user_list_header'>
                    <h2>Chat</h2>
                    <IoMdMore onClick={(event) => openNewChat(event)} className='sm_chat_body_header_user_actions_more_icon' />
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button'
                        }}
                        disableScrollLock={true}

                    >
                        <AddNewChat setIsUpdate={setIsUpdate} setAnchorEl={setAnchorEl}/>
                    </Menu>
                </div>
                <div className='sm_chat_user_list_search_input'>
                    <IoMdSearch className='sm_chat_user_list_search_input_icon' />
                    <input value={searchKey} onChange={(e) => handleChatSearch(e.target.value)} type="text" placeholder='Search' />
                </div>
                {(chatList?.length === 0) ?
                    <div className='sm_chat_no_user_chat_available'>
                        <p>No chat fount</p>
                        <button type='button' onClick={(e) => openNewChat(e)}>Start new chat</button>
                    </div>
                    :
                    <div className='sm_chat_user_Message_list'>
                        {
                            chatList?.map((ru, index) =>
                                <ChatUserCard key={index}
                                    chat={ru}
                                    currentChat={currentChat}
                                    onClick={() => {
                                        handleOpenChat();
                                        dispatch(chatActions.setCurrentChat(ru))
                                        navigate(`/chat/chat-body/${ru?.chatId}`,
                                            {
                                                state: {
                                                    currentChat: ru
                                                }
                                            })
                                    }} />
                            )
                        }
                    </div>}

            </div>
        </div>
    )
}

export default ChatRoom